import React from 'react';
import { Document, Page, Text, View, StyleSheet } from '@react-pdf/renderer';

// Standard font for clean look
const styles = StyleSheet.create({
  page: {
    padding: 50,
    fontSize: 11,
    fontFamily: 'Helvetica',
    color: '#333333',
    lineHeight: 1.5,
  },
  header: {
    marginBottom: 30,
  },
  senderName: {
    fontSize: 14,
    fontWeight: 'bold',
    marginBottom: 2,
  },
  senderInfo: {
    marginBottom: 2,
  },
  dateLocation: {
    marginTop: 20,
    textAlign: 'right',
    marginBottom: 30,
  },
  subject: {
    fontWeight: 'bold',
    marginTop: 10,
    marginBottom: 25,
    textDecoration: 'underline',
  },
  content: {
    textAlign: 'justify',
  },
  paragraph: {
    marginBottom: 15,
  },
  signature: {
    marginTop: 30,
  }
});

const CLDocument = ({ content, language = 'fr' }) => {
  // Parsing the content to extract header info if present or handle raw text
  const lines = content.split('\n');
  
  return (
    <Document>
      <Page size="A4" style={styles.page}>
        {/* Header Section */}
        <View style={styles.header}>
          <Text style={styles.senderName}>Alexandre Sanou</Text>
          <Text style={styles.senderInfo}>Architecte Solution IA & Data Scientist</Text>
          <Text style={styles.senderInfo}>5+ ans d'expérience</Text>
          <Text style={styles.senderInfo}>06 03 84 63 47</Text>
          <Text style={styles.senderInfo}>sanoualexandreism@gmail.com</Text>
          <Text style={styles.senderInfo}>Site Web: https://alexandresanou.com</Text>
          <Text style={styles.senderInfo}>LinkedIn: linkedin.com/in/alexandre-sanou</Text>
        </View>

        {/* Date and Location */}
        <View style={styles.dateLocation}>
          <Text>{language === 'en' ? 'Paris, ' : 'Fait à Paris, le '}{new Date().toLocaleDateString(language === 'en' ? 'en-US' : 'fr-FR')}</Text>
        </View>

        {/* Body Section */}
        <View style={styles.content}>
          {lines.map((line, index) => {
            const isSubject = line.toLowerCase().startsWith('objet :') || line.toLowerCase().startsWith('subject:');
            
            if (isSubject) {
              return <Text key={index} style={styles.subject}>{line}</Text>;
            }
            
            return (
              <Text key={index} style={styles.paragraph}>
                {line}
              </Text>
            );
          })}
        </View>

        {/* Signature Placeholder if not in text */}
        {!content.includes('Alexandre Sanou') && (
          <View style={styles.signature}>
            <Text>Cordialement,</Text>
            <Text>Alexandre Sanou</Text>
          </View>
        )}
      </Page>
    </Document>
  );
};

export default CLDocument;
